import { render, staticRenderFns } from "./MentionInput.vue?vue&type=template&id=9a2de8ea&scoped=true"
import script from "./MentionInput.vue?vue&type=script&lang=js"
export * from "./MentionInput.vue?vue&type=script&lang=js"
import style0 from "./MentionInput.vue?vue&type=style&index=0&id=9a2de8ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a2de8ea",
  null
  
)

export default component.exports